export const YEAR_RANGE_START_OFFSET = 10;
export const YEAR_RANGE_END_OFFSET = 3;

export const startYear = new Date().getFullYear() - YEAR_RANGE_START_OFFSET;
export const endYear = new Date().getFullYear() + YEAR_RANGE_END_OFFSET;
